import { DeviceNotifications, Notifications, StationNotifications } from '@.pages';

import { RoutePage } from '../types';

export const NotificationsPage: RoutePage = {
    url: 'notifications',
    component: <Notifications />,
    permissions: {
        entity: 'MonitoringStations',
        right: 'read',
    },
    sidebar: {
        name: 'Notifications',
        hasNotificationsBadge: true,
    },
    children: [
        {
            url: 'station/:stationId',
            component: <StationNotifications />,
        },
        {
            url: 'station/:stationId/device/:deviceId',
            component: <DeviceNotifications />,
        },
    ],
};
